import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function NewsList() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [selectedPlatform, setSelectedPlatform] = useState('All');
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 50;

  useEffect(() => {
    const handle = setTimeout(() => {
      setSearch(searchInput);
      setCurrentPage(1);
    }, 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setLoading(true);
    axios.get('/api/news', {
      params: {
        page: currentPage,
        limit: itemsPerPage,
        platform: selectedPlatform !== 'All' ? selectedPlatform : undefined,
        search: search || undefined,
      },
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        setNews(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
        setTotalItems(res.data.pagination.total);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [currentPage, selectedPlatform, search]);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';

    const match = dateStr.toString().match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
    if (!match) return dateStr.toString().slice(0, 19) || 'N/A';

    const [, year, month, day, hour, minute, second] = match;
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  };





  return (
      <div className="w-full p-0">
      <div className="flex justify-between items-center mb-2 px-8">

        <h2 className="text-2xl font-bold text-gray-900 pl-4">Media Analytics List</h2>
        
      </div>

      <div className="bg-white shadow-none border-t border-gray-200 w-full">
        <div className="px-8 py-3 border-b border-gray-200">
          <div className="grid gap-4 md:grid-cols-[1fr_auto] items-end px-0 py-0">

            <input
              type="text"
              placeholder="Search by title, company, category, platform, account, tone..."
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <div className="flex flex-col gap-2">
              <label htmlFor="platform-filter" className="text-sm font-medium text-gray-700">
                Filter Platform
              </label>
              <select
                id="platform-filter"
                value={selectedPlatform}
                onChange={(e) => { setSelectedPlatform(e.target.value); setCurrentPage(1); }}
                className="w-full max-w-xs px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              >
                <option value="All">All Platforms</option>
                <option value="Media Online">Media Online</option>
                <option value="Media Sosial">Media Sosial</option>
                <option value="Media Cetak">Media Cetak</option>
              </select>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="p-8 text-center">Loading...</div>
        ) : (
          <div className="w-full" id="mtm55p">
            <table className="w-full table-auto divide-y divide-gray-200" id="4c1d8g">

              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Publish Date</th>
                  <th className="w-24 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                  <th className="w-20 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                  <th className="w-24 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                  <th className="w-24 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Account</th>
                  <th className="w-[18rem] px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Titles</th>
                  <th className="w-16 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Link</th>
                  <th className="w-20 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tone</th>
                  <th className="w-16 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {news.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {formatDate(item.publish_datetime)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 truncate max-w-[9rem]">
                      {item.brand_name || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 truncate max-w-[7rem]">
                      {item.platform || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 truncate max-w-[8rem]">
                      {item.main_category || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 truncate max-w-[8rem]">
                      {item.media_name || 'N/A'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-normal break-words max-w-[18rem]" title={item.headline || ''}>
                      {item.headline || 'N/A'}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <a
                        href={item.url_link || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="max-w-[8rem] truncate block text-indigo-600 hover:text-indigo-900 hover:underline"
                      >
                        {item.url_link ? 'View' : 'N/A'}
                      </a>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 truncate max-w-[7rem]">
                      {item.tonality || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <button
                        onClick={() => setSelectedItem(item)}
                        className="text-indigo-600 hover:text-indigo-900"
                      >
                        Action
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {news.length === 0 && (
              <tbody>
                <tr>
                  <td
                    colSpan={9}
                    className="p-8 text-center text-gray-500"
                  >
                    No data found.{' '}
                    <a href="/upload" className="text-indigo-600 hover:underline">
                      Upload an Excel
                    </a>{' '}
                    to populate data or check media_analytics table.
                  </td>
                </tr>
              </tbody>
            )}

          </div>
        )}
        {/* Pagination Controls */}
        {!loading && totalPages > 1 && (
          <div className="bg-white px-0 py-4 border-t border-gray-200 flex items-center justify-between">
            <div className="text-sm text-gray-600 px-4">
              Showing page <span className="font-semibold">{currentPage}</span> of <span className="font-semibold">{totalPages}</span> 
              ({totalItems} total items)
            </div>
            <div className="flex items-center gap-2 px-4">
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                className="px-3 py-2 rounded-md text-sm font-medium bg-gray-100 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200"
              >
                Previous
              </button>
              
              {/* Page Numbers */}
              <div className="flex gap-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-3 py-2 rounded-md text-sm font-medium ${
                        currentPage === pageNum
                          ? 'bg-indigo-600 text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>

              <button
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                className="px-3 py-2 rounded-md text-sm font-medium bg-gray-100 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {selectedItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" onClick={() => setSelectedItem(null)}>
                  <div className="relative top-20 p-5 mx-4 md:mx-6 border w-auto shadow-none rounded-md bg-white" onClick={(e) => e.stopPropagation()}>

            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Media Analytics Detail</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div><strong>Date:</strong> {formatDate(selectedItem.publish_datetime)}</div>
                <div><strong>Category:</strong> {selectedItem.main_category || 'N/A'}</div>
                <div><strong>Platform:</strong> {selectedItem.platform || 'N/A'}</div>
                <div><strong>Account:</strong> {selectedItem.media_name || 'N/A'}</div>
                <div><strong>Title:</strong> <span title={selectedItem.headline || ''}>{selectedItem.headline || 'N/A'}</span></div>
                <div><strong>Company/Brand:</strong> {selectedItem.brand_name || 'N/A'}</div>
                <div><strong>Tone:</strong> {selectedItem.tonality || 'N/A'}</div>
                <div><strong>Media Reach:</strong> {selectedItem.media_reach ? selectedItem.media_reach.toLocaleString() : 'N/A'}</div>
                <div><strong>Likes:</strong> {selectedItem.likes || '0'}</div>
                <div><strong>Views:</strong> {selectedItem.views || '0'}</div>
                <div><strong>Shares:</strong> {selectedItem.shares || '0'}</div>
                <div><strong>Comments:</strong> {selectedItem.comments || '0'}</div>
                <div className="md:col-span-2">
                  <strong>Link:</strong> <a href={selectedItem.url_link} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">{selectedItem.url_link || 'N/A'}</a>
                </div>
              </div>
              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setSelectedItem(null)}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
